/* eslint-disable camelcase */
import Store from "~/common/Store";
import MarketingEventHelpers from "../MarketingHelpers/MarketingEventHelpers";
import { loadedAnalytics } from "./loadAnalyticsBrowser";

export type CustomerIoOptionalProperties = {
  item_brand: string;
  item_image_url: string;
  item_review_count: string;
  item_overall_rating: number;
  item_quantity: string;
};

export type CustomerIoProduct = {
  item_category1?: string;
  item_category2?: string;
  item_category3?: string;
  item_category4?: string;
  item_category5?: string;
  item_brand?: string;
  item_id: string;
  item_name: string;
  item_price: string;
  item_quantity?: string;
  item_review_count?: string;
  lowest_breadcrumb?: string;
  second_lowest_breadcrumb?: string;
  item_review_rating?: number;
  item_image_url?: string;
} & Partial<CustomerIoOptionalProperties>;

export const sendCustomerIoBaseEvent = async (
  eventName: string,
  products: CustomerIoProduct[],
) => {
  if (loadedAnalytics) {
    loadedAnalytics.track(eventName, {
      event_timestamp: MarketingEventHelpers.getCurrentTimeStamp(),
      internal_user_index: Store.getState().user.analyticsData.uq_customer_id,
      currency: "USD",
      product: products,
    });
  }
};

export const sendCustomerIoPurchaseEvent = async (
  products: CustomerIoProduct[],

  orderId: string,

  orderSubtotal: number,

  couponCode: string,

  paymentType: string,

  isGuestCheckout: boolean,

  isFirstTimePurchaser: boolean,

  addressType: string,
) => {
  if (loadedAnalytics) {
    loadedAnalytics.track("purchase_complete", {
      event_timestamp: MarketingEventHelpers.getCurrentTimeStamp(),
      internal_user_index: Store.getState().user.analyticsData.uq_customer_id,
      product: products,
      order_id: orderId,
      affiliation: "WebstaurantStore",
      revenue: orderSubtotal,
      coupon: couponCode,
      payment_type: paymentType,
      is_guest_checkout: isGuestCheckout ? "1" : "0",
      first_time_purchaser: isFirstTimePurchaser ? "1" : "0",
      address_type: addressType,
    });
  }
};

export type CustomerIoGuestCheckoutParams = {
  guest_checkout_email: string;
  subscribe_to_newsletter: boolean;
  create_account: boolean;
};

export const sendGuestCheckoutEvent = (
  guestCheckoutEvent: CustomerIoGuestCheckoutParams,
) => {
  if (loadedAnalytics) {
    const userAnaltyicsData = Store.getState().user.analyticsData;
    loadedAnalytics.track("guest_checkout", {
      event_timestamp: MarketingEventHelpers.getCurrentTimeStamp(),
      is_internal: userAnaltyicsData.is_internal,
      internal_logged_in_as_user: userAnaltyicsData.logged_in_as_user,
      ...guestCheckoutEvent,
    });
  }
};

export type AddToWishListEventParams = {
  add_to_wishlist_value: string;
  currency: string;
  product: CustomerIoProduct[];
};

export const sendAddToWishListEvent = (
  addToWishListEvent: AddToWishListEventParams,
) => {
  if (loadedAnalytics) {
    loadedAnalytics.track("add_to_wishlist", {
      event_timestamp: MarketingEventHelpers.getCurrentTimeStamp(),
      internal_user_index:
        Store.getState().user.analyticsData.uq_customer_id ?? "",
      ...addToWishListEvent,
    });
  }
};

export const sendCustomerIoViewProductEvent = (
  products: CustomerIoProduct[],
) => {
  if (loadedAnalytics) {
    loadedAnalytics.track("view_product", {
      event_timestamp: MarketingEventHelpers.getCurrentTimeStamp(),
      internal_user_index:
        Store.getState().user.analyticsData.uq_customer_id ?? "",
      currency: "USD",
      product: products,
    });
  }
};

export type CustomerIoUpdateCartAction =
  | "Add to Cart"
  | "Remove from Cart"
  | "Empty Cart";

export const sendCustomerIoUpdateCartEvent = (
  action: CustomerIoUpdateCartAction,
  products: CustomerIoProduct[],
  coupon: string,
) => {
  if (loadedAnalytics) {
    loadedAnalytics.track("update_cart", {
      event_timestamp: MarketingEventHelpers.getCurrentTimeStamp(),
      internal_user_index:
        Store.getState().user.analyticsData.uq_customer_id ?? "",
      products,
      action,
      cart_value: Store.getState().user.analyticsData.cart_total,
      coupon,
    });
  }
};

export const sendCustomerIoMobilePageViewEvent = () => {
  if (loadedAnalytics) {
    loadedAnalytics.track("mobile_page_view", {
      event_timestamp: MarketingEventHelpers.getCurrentTimeStamp(),
      device_category: "Mobile",
      user_agent: navigator.userAgent,
    });
  }
};
